import { type GridApi, type IRowNode } from "ag-grid-community"

import { pricingCalc } from "../../utils"

import type { PricingGridRow } from "./types"

import { type PriceChangeItem } from "@/graphql/codegen/graphql"

interface ColHandlerParams {
  api: GridApi<PricingGridRow>
  node: IRowNode<PricingGridRow>
  rowIndex: number
  modifiedRows: Set<number>
}

type ColHandler = (params: ColHandlerParams) => void

const handleNewPriceChange: ColHandler = ({ api, node }) => {
  if (!node.data) return
  const { acceptedCost, newPrice } = node.data

  node.data.newMargin = pricingCalc.newMargin({ newPrice, acceptedCost })

  api.refreshCells({ rowNodes: [node], columns: ["newMargin"] })
}

const createSpannedColHandler =
  (columnId: keyof PriceChangeItem): ColHandler =>
  ({ api, node, modifiedRows }) => {
    if (!node.data) return
    const editedItem = node.data.item
    const rowNodes: IRowNode<PricingGridRow>[] = []
    api.forEachNode((rowNode) => {
      if (rowNode.data?.item !== editedItem) return
      rowNodes.push(rowNode)
      if (rowNode.rowIndex !== null && rowNode.rowIndex !== undefined) modifiedRows.add(rowNode.rowIndex)
    })
    api.refreshCells({ rowNodes, columns: [columnId], force: true })
    api.redrawRows({ rowNodes })
  }

export const COL_HANDLERS: Partial<Record<string, ColHandler>> = {
  newPrice: handleNewPriceChange,
  freight: createSpannedColHandler("freightTerms"),
  billBack: createSpannedColHandler("billBack"),
  effectiveDate: createSpannedColHandler("effectiveDate"),
  expirationDate: createSpannedColHandler("expirationDate"),
}
